import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { CreateJobRequest, IJob } from "../models/Job";
// import { ISetting, ISettingsResponse } from "../models/Setting";

export default function useJobMutations() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const create = useMutation(
    (job: CreateJobRequest) => post(`/job`, job),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["jobs"]);
        queryClient.refetchQueries(["lead"]);
        queryClient.refetchQueries(["vehicles"]);
      },
    }
  );

  const update = useMutation(
    (job: IJob) => put(`/job/${job.id}`, job),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["jobs"]);
      },
    }
  );

  const remove = useMutation(
    (id: string) => del(`/job/${id}`),
    {
      onSuccess: () => {
        queryClient.refetchQueries(["jobs"]);
        queryClient.refetchQueries(["lead"]);
        queryClient.refetchQueries(["vehicles"]);
      },
    }
  );

  return {
    create,
    update,
    remove
  };
}
